<template>
  <svg :width="size" :height="size" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Trophy with flames -->
    <path d="M10 6h12v10c0 4-2.5 6-6 7-3.5-1-6-3-6-7V6z" :fill="color" />
    <!-- Trophy handles -->
    <path d="M10 9H7c-1 0-2 1-2 2v2c0 2 1.5 3 3 3h2" :stroke="color" stroke-width="2.5" fill="none" stroke-linecap="round" />
    <path d="M22 9h3c1 0 2 1 2 2v2c0 2-1.5 3-3 3h-2" :stroke="color" stroke-width="2.5" fill="none" stroke-linecap="round" />
    <!-- Base -->
    <rect x="12" y="23" width="8" height="2" rx="1" :fill="color" />
    <rect x="10" y="25" width="12" height="3" rx="1" :fill="color" opacity="0.7" />
    <!-- Flame tips on top -->
    <path d="M13 6c0-2 1-4 2-4s-1 2 1 3" :stroke="color" stroke-width="1.5" fill="none" stroke-linecap="round" opacity="0.7" />
    <path d="M16 6c0-3 1-5 2-5s-1 3 1 4" :stroke="color" stroke-width="1.5" fill="none" stroke-linecap="round" opacity="0.7" />
    <path d="M19 6c0-2 1-4 2-4s-1 2 1 3" :stroke="color" stroke-width="1.5" fill="none" stroke-linecap="round" opacity="0.7" />
  </svg>
</template>
<script setup lang="ts">
withDefaults(defineProps<{ size?: number; color?: string }>(), {
  size: 28,
  color: '#CC0000',
});
</script>
